import { useAppConfig } from "@/api/app-config/useAppConfig";

// NOTE: Returns true when the IS_AGENTS_ENABLED env var is set to "true" on the server.
// Reads from the public /app-config endpoint — no auth or integration permission required.
export const useAgentsEnabled = (): boolean => {
  const { data } = useAppConfig();
  return data?.isAgentsEnabled ?? false;
};
